import {
  getVisaA8LabelFromValue,
  options as visaA8Options,
} from "@/components/input/custom/visa/VisaA8";
import { cn } from "@/lib/utils";
import { EntryValueLabel } from "../EntryValueLabel";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface VisaA8EntryValueProps
  extends Omit<BaseEntryValueProps, "value"> {
  value: number | null;
}

export function VisaA8EntryValue(
  { value, inputLabel, size, className, ...props }: VisaA8EntryValueProps,
) {
  const result = value != null ? getVisaA8LabelFromValue(value) : null;
  const branchAnswer = result
    ? visaA8Options.find((opt) => opt.value === result.branch)?.answer
    : null;

  return (
    <div>
      <EntryValueLabel size={size}>
        If you have no pain, some pain, or pain that stops you from completing
        sporting activities, for how long can you train/practise?
      </EntryValueLabel>
      <div className="flex flex-col gap-1 pt-2">
        {branchAnswer && (
          <span
            className={cn(
              "mb-1 text-md text-slate-700",
              size === "sm" ? "text-sm" : "text-md",
            )}
          >
            {branchAnswer}
          </span>
        )}
        {result && (
          <span
            className={cn(
              "text-slate-700 dark:text-white",
              size === "sm" ? "text-md" : "text-lg",
            )}
          >
            {result.label} min
          </span>
        )}
      </div>
    </div>
  );
}
